import React from 'react';
import PropTypes from 'prop-types';

import logo from '../../../assets/images/sp-logo.svg';

import {
  Chevron,
  ExpandButton,
  ExpandButtonWrapper,
  ExpandedWrapper,
  Logo,
  LogoutButton,
  LogoutButtonPlaceholder,
  LogoSection,
  LogoWrapper,
  MainSection,
  SwitchButton,
  SwitchSection,
  UserLocation,
  UserName,
  Wrapper,
} from './MobileHeader.style';
import Placeholder from '../../Placeholder';

class MobileHeader extends React.Component {
  state = {
    expanded: false,
  };

  handleClickExpand = () => {
    this.setState(state => ({
      ...state,
      expanded: !state.expanded,
    }));
  };

  render() {
    const { location, copy, stylist, onLogout, onResetCurrentUser } = this.props;
    const { expanded } = this.state;
    return (
      <Wrapper>
        <LogoSection>
          <LogoWrapper>
            <Logo src={logo} alt="logo" />
          </LogoWrapper>
          {['login', 'forgot-password', 'change-password', 'sign-up'].every(el => !location.pathname.includes(el)) && (
            <ExpandButtonWrapper>
              <ExpandButton onClick={this.handleClickExpand}>
                <Chevron expanded={expanded} />
              </ExpandButton>
            </ExpandButtonWrapper>
          )}
        </LogoSection>
        {['login', 'forgot-password', 'change-password', 'sign-up'].every(el => !location.pathname.includes(el)) && (
          <ExpandedWrapper expanded={expanded}>
            <MainSection>
              <div>
                <UserName>
                  {stylist.given_name || <Placeholder w="100px" h="20px" />}{' '}
                  {stylist.family_name || <Placeholder w="100px" h="20px" />}
                </UserName>
                <UserLocation>
                  {stylist.city || <Placeholder w="100px" h="20px" />}{' '}
                  {stylist.salon || <Placeholder w="100px" h="20px" />}
                </UserLocation>
                {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
                  <LogoutButton onClick={onLogout}>{copy.log_out}</LogoutButton>
                ) : (
                  <LogoutButtonPlaceholder>
                    <Placeholder h="28px" w="100px" />
                  </LogoutButtonPlaceholder>
                )}
              </div>
            </MainSection>

            {location.pathname.indexOf('retrieve-profile') < 0 && (
              <SwitchSection>
                <SwitchButton onClick={onResetCurrentUser}>
                  <svg width="36" height="34" viewBox="0 0 36 34">
                    <g fill="none" fillRule="evenodd">
                      <g stroke="#FEFEFE" strokeWidth=".8">
                        <path d="M32.736 19.091c-.433 7.92-7.08 14.21-15.214 14.21-8.135 0-14.78-6.29-15.214-14.21" />
                        <path d="M29.547 21.311l3.2-2.211 2.241 3.158" />
                      </g>
                      <g stroke="#FEFEFE" strokeWidth=".8">
                        <path d="M2.878 15.505C3.307 7.42 9.88 1 17.928 1s14.62 6.42 15.05 14.505" />
                        <path d="M6.378 13.086l-3.294 2.419L.778 12.05" />
                      </g>
                      <g fill="#FFF">
                        <path d="M17.636 15.757c-1.877 0-3.414-1.512-3.414-3.361v-.587c0-1.766 1.468-3.211 3.262-3.211h.342c1.774 0 3.225 1.428 3.225 3.175v.623c0 1.849-1.537 3.361-3.415 3.361zM23.394 17.074l-2.46-.895c-.704.926-2.12 1.532-3.38 1.532-1.207 0-2.582-.554-3.289-1.414l-1.958.777c-1.17.378-1.73 1.34-2.165 2.469L9.1 23.549h17.5l-1.042-4.006c-.321-1.177-.962-2.1-2.164-2.47z" />
                      </g>
                    </g>
                  </svg>
                </SwitchButton>
              </SwitchSection>
            )}
          </ExpandedWrapper>
        )}
      </Wrapper>
    );
  }
}

MobileHeader.defaultProps = {
  copy: {},
};

MobileHeader.propTypes = {
  copy: PropTypes.shape({}),
  location: PropTypes.shape().isRequired,
  stylist: PropTypes.shape({}).isRequired,
  onLogout: PropTypes.func.isRequired,
  onResetCurrentUser: PropTypes.func.isRequired,
};

export default MobileHeader;



// WEBPACK FOOTER //
// ./src/components/StylistHeader/MobileHeader/MobileHeader.js